import {
  PopoverBackdrop,
  PopoverPanel as HeadlessPopoverPanel,
} from '@headlessui/react'
import cx from 'classnames'
import type { ComponentProps } from 'react'

import { zIndexStyles } from '../../libs/zIndexStyles'
import { backdropStyles } from '../modal/backdropStyles'

type Props = ComponentProps<typeof HeadlessPopoverPanel> & {
  isShowingBackdrop?: boolean
}

export const PopoverPanel = ({
  isShowingBackdrop,
  className,
  ...props
}: Props) => (
  <>
    {isShowingBackdrop && (
      <PopoverBackdrop
        className={cx(backdropStyles, zIndexStyles('popoverBackdrop'))}
      />
    )}
    <HeadlessPopoverPanel
      className={cx(className, zIndexStyles('popovers'))}
      {...props}
    />
  </>
)
